// Story 100 (S101/S102, RN39 + DN-6): pure FORMATTING of an already-computed, signed deviation.
// Per 03-dominio.md §8 ("Ningun dominio en el front... no calcula... desviación"), Jupiter never
// computes the deviation itself -- Sun resolves the signed value and this module only turns it
// into "Dd Hh" text with sign, plus whether it should be highlighted as a delay (RN39: positive =
// later than promised).
//
// `totalMinutes` is `null`/`undefined` when there is nothing to show (RN40.1/RN41: a blank cell is
// NOT the same as zero -- "still within deadline" and "not applicable yet" are both blank on
// purpose).
export const DEVIATION_LATE_COLOR = '#f44336'

const MINUTES_PER_HOUR = 60
const MINUTES_PER_DAY = 24 * MINUTES_PER_HOUR

export const formatDeviation = (totalMinutes) => {
  if (totalMinutes === null || totalMinutes === undefined) {
    return { text: '', isLate: false }
  }
  const sign = totalMinutes < 0 ? '-' : '+'
  const absMinutes = Math.abs(totalMinutes)
  const days = Math.floor(absMinutes / MINUTES_PER_DAY)
  const hours = Math.floor((absMinutes % MINUTES_PER_DAY) / MINUTES_PER_HOUR)
  const text = days > 0 ? `${sign}${days}d ${hours}h` : `${sign}${hours}h`
  return { text, isLate: totalMinutes > 0 }
}
